import React from 'react';
import {
  View,
  type NativeSyntheticEvent,
  TextInput,
  type TextInputFocusEventData,
  type TextInputKeyPressEventData,
} from 'react-native';
import colors from '~/assets/themes/colors';

interface DigitInput {
  value?: string;
  withoutMargin?: boolean;
  error?: boolean;
  focused?: boolean;
  autoFocus?: boolean;
  secureTextEntry?: boolean;
  onFocus?: (e: NativeSyntheticEvent<TextInputFocusEventData>) => void;
  onChangeText?: (text: string) => void;
  onKeyPress?: (e: NativeSyntheticEvent<TextInputKeyPressEventData>) => void;
  wrongCode?: boolean;
}

const DigitInput = React.forwardRef<TextInput, DigitInput>(
  (
    {
      value,
      withoutMargin,
      error,
      focused,
      autoFocus,
      secureTextEntry,
      onFocus,
      onChangeText,
      onKeyPress,
      wrongCode,
    },
    ref
  ) => {
    return (
      <View
        className={`w-12 h-12 rounded-[50px] border-dark-600 border-[1px] justify-center items-center ${
          error
            ? 'border-error-600'
            : focused
            ? 'border-slate-800'
            : 'border-dark-600'
        } ${withoutMargin ? '' : 'ml-6'} ${
          error ? 'text-dark-400' : 'text-primary-600`'
        } ${wrongCode ? 'border-error-500' : ''}`}
      >
        <TextInput
          className={`text-sm w-9 h-9 rounded-2xl border-[1px] text-center ${
            error
              ? 'border-error-600'
              : focused
              ? 'border-light-300'
              : 'border-light-300'
          } ${error ? 'text-error-600' : 'text-dark-400'}`}
          maxLength={1}
          keyboardType="decimal-pad"
          secureTextEntry={secureTextEntry}
          selectionColor={colors.primary[600]}
          ref={ref}
          autoFocus={autoFocus}
          onFocus={onFocus}
          onChangeText={onChangeText}
          onKeyPress={onKeyPress}
          value={value}
        />
      </View>
    );
  }
);

export default DigitInput;
